import { render, staticRenderFns } from "./ServeReport.vue?vue&type=template&id=2d657668&scoped=true&"
import script from "./ServeReport.vue?vue&type=script&lang=js&"
export * from "./ServeReport.vue?vue&type=script&lang=js&"
import style0 from "./ServeReport.vue?vue&type=style&index=0&id=2d657668&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d657668",
  null
  
)

export default component.exports